export default __webpack_public_path__ + "static/media/cafe_2.d036a5a0.jpg";